/**
 * Helper functions for multi-client user model transformations.
 * Handles conversion between the single-select form field (associatedClientId)
 * and the multi-client API field (associatedClientIds).
 */

/**
 * Converts a user form model with a single associatedClientId
 * into the API format with associatedClientIds array.
 * Removes the legacy associatedClientId field from the model.
 *
 * @param {Object} model - The user form model
 * @returns {Object} The transformed model with associatedClientIds array
 */
export function adaptAssociatedClientIdToList(model) {
    const newModel = { ...model };
    let ids = newModel.associatedClientIds;
    if (typeof ids === "string") {
        newModel.associatedClientIds = ids
            .split(",")
            .filter(function(id) { return id.trim() !== ""; })
            .map(function(id) { return parseInt(id); });
    } else if (typeof ids === "number") {
        // Single value selected — wrap in array
        newModel.associatedClientIds = [ids];
    } else if (!Array.isArray(ids)) {
        newModel.associatedClientIds = [];
    }
    return newModel;
}

/**
 * Creates the initial empty user model for the user creation form.
 *
 * @param {number|null} clientId - The current client ID context (if in client users page)
 * @returns {Object} An empty user model with default values
 */
export function createEmptyAssociatedClientFields(clientId) {
  return {
    associatedClientIds: clientId ? [clientId] : [],
  };
}

/**
 * Formats the display of associated clients in the role column.
 * Returns the client names in parentheses format: " (Client A, Client B)"
 * Returns empty string if no clients or in client users view.
 *
 * @param {Array} associatedClients - Array of client objects with name property
 * @param {boolean} isClientUsersView - Whether in client-specific users view
 * @returns {string} Formatted client names string
 */
export function formatAssociatedClientsDisplay(associatedClients, isClientUsersView) {
  if (isClientUsersView) {
    return "";
  }
  if (associatedClients && associatedClients.length > 0) {
    return ` (${associatedClients.map(c => c.name).join(", ")})`;
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/users/usersMultiClientHelper.js